<template>
  <a class="webinar-button" :href="link" :target="currentTab ? null : '_blank'">
    <slot></slot>
  </a>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import { useStore } from 'vuex'
import { key } from '@/vue/store'

export default defineComponent({
  name: 'Button',
  props: {
    href: {
      type: String as PropType<string>,
      required: true,
    },
    currentTab: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(props) {
    const store = useStore(key)
    const utm = computed(() => store.state.userUtm)
    const link = computed(() => {
      let l: string = props.href
      if (utm.value) {
        l += l.includes('?') ? '&' : '?'
        l += utm.value.replace(/^\?/, '')
      }
      return l
    })
    return { link }
  },
})
</script>

<style lang="stylus">
.webinar-button
  background var(--button-color)
  color var(--button-text-color)
  text-decoration none
  text-transform uppercase
  white-space nowrap
  text-overflow ellipsis
  max-width 100%
  font-weight bold
  padding 8px 15px
  border-radius 3px
  margin 0 10px 10px 0
</style>
